"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    if (!theme) {
        theme = styling_1.getTheme();
    }
    var DefaultStyles = {
        root: {
            padding: 10
        },
        editor: {},
        section: {},
        sectionTitle: {
            fontSize: styling_1.FontSizes.icon,
            margin: 0,
            paddingTop: 16,
            paddingBottom: 16
        },
        sectionBody: {},
        actions: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            selectors: {
                ".action+.action": {
                    marginLeft: 8
                }
            }
        }
    };
    return styling_1.concatStyleSets(DefaultStyles, customStyles);
});
exports.getStyles = getStyles;
